import ParentTreeFragmentAllLocales from '@/lib/fragments/parent-tree/all-locales'
import RedirectLinkFragment from '@/lib/fragments/redirect-link'
import SectionPaddingFragment from '@/lib/fragments/section-padding'
import TeamMemberFragment from '@/lib/fragments/team-member'
import { graphql } from '@/lib/query'

const SectionSliderFragment = graphql(
  /* GraphQL */ `
    fragment SectionSliderFragment on SectionSliderRecord @_unmask {
      _modelApiKey
      __typename
      variant
      hide
      bg
      scrollbar
      title
      titleRight
      titleFirstSlide
      content
      teamMembers {
        ...TeamMemberFragment
      }
      pages {
        redirect {
          ...RedirectLinkFragment
        }
        _allSlugLocales {
          locale
          value
        }
        pageTitle
        excerpt
        subtitle
        slug
        image {
          ...ImageFragment
        }

        ...ParentTreeFragmentAllLocales
      }
    }
  `,
  [
    SectionPaddingFragment,
    TeamMemberFragment,
    RedirectLinkFragment,
    ParentTreeFragmentAllLocales
  ]
)

export default SectionSliderFragment
